import { Component, OnInit, Inject, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
//import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';


export interface DefaultSearchDialogData {
  searchText: string;
}

@Component({
  selector: 'app-default-search-dialog',
  templateUrl: './default-search-dialog.component.html',
  styleUrls: ['./default-search-dialog.component.css']
})
export class DefaultSearchDialogComponent implements OnInit {


  @ViewChild('searchText',{static:true}) searchText: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<DefaultSearchDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DefaultSearchDialogData) { }

  onNoClick(): void {


    this.dialogRef.close();
  }

  closeDialog(): void {


  
    this.dialogRef.close(this.data.searchText);
  }

  ngOnInit() {
  }



}


